module.exports = __webpack_public_path__ + "img/avtar.d5013f6c.jpg";